import { LOGIN } from './index';
import { Action } from '../action';
import { LoginForm } from '@shared/core';

export class LoginClickSigninAction implements Action {
	readonly type = LOGIN.CLICK_SIGNIN;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class LoginClickLogoutAction implements Action {
	readonly type = LOGIN.CLICK_LOGOUT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class LoginClickRegisterAction implements Action {
	readonly type = LOGIN.CLICK_REGISTER;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class LoginClickForgotPasswordAction implements Action {
	readonly type = LOGIN.CLICK_FORGOT_PASSWORD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class LoginFormUpdateAction implements Action {
	readonly type = LOGIN.FORM_UPDATE;
	constructor(
		public payload: LoginForm,
		public correlationId?: number
	) {}
}

export class LoginFormResetAction implements Action {
	readonly type = LOGIN.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class LoginInitAction implements Action {
	readonly type = LOGIN.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class LoginDestroyAction implements Action {
	readonly type = LOGIN.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
